export const isDevClient = process.env.REACT_APP_CLIENT_NODE_ENV === 'devclient';
